import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

export type GetCancelReasonsResponse = CancelReason[];

export interface CancelReason {
  id: number;
  create_date: string;
  modify_date: string;
  name: string;
  is_active: boolean;
  generic_followup: string;
}

export async function getCancelReasons() {
  return send<GetCancelReasonsResponse>({
    path: '/api/get_cancel_reasons/',
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
